import * as React from "react";

const IconHeaderCaretLargeDown: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="currentColor"><polygon fill="currentColor" points="4.545 5.341 4.943 4.943 8.693 1.195 9.091 .797 8.295 .002 7.896 .401 4.545 3.752 1.193 .398 .795 0 0 .797 .398 1.195 4.146 4.945 4.545 5.344" transform="translate(.956 .453)"/></svg>;
};

export default React.memo(IconHeaderCaretLargeDown);
